import Enum from '@square/dashboard-utilities/utils/enum';
import Duration from '@square/dashboard-data/models/squareup/sub2/duration';
import { BillingCycle } from '@square/dashboard-data/models/squareup/sub2/external-plan';
import Pricing from '@square/dashboard-data/models/squareup/sub2/pricing';
import Feature from '@square/dashboard-utilities/utils/sub2/feature';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
export const AvailabilityStatus = new Enum(['AVAILABLE', 'DEPRECATED', 'DELETED']);
export default ProtoBaseModel.extend({
  name: attr(String),
  token: attr(String),
  productToken: attr(String),
  availabilityStatus: attr(AvailabilityStatus),
  pricing: attr(Pricing),
  renewalCycle: attr(Duration),
  freeTrialDuration: attr(Duration),
  taxClass: attr(String),
  features: repeated(Feature),
  noObligationFreeTrialExpiredDuration: attr(Duration),
  planBillingCycle: attr(BillingCycle)
});